__turbopack_context__.v({
  "folderTreeRoot": "FolderTree-module__HTqwJW__folderTreeRoot",
  "noResults": "FolderTree-module__HTqwJW__noResults",
});
